import React, { useState } from "react";
import GlobalFilter from "components/Table/GlobalFilter";
import SelectFields from "components/Table/SelectFields";
import Button from "components/Form/fields/Button";
import get from "lodash/get";
import xor from "lodash/xor";
import IconButtonBar from "components/IconButtonBar";
import HoverIconButton from "components/HoverIconButton";
import Modal from "components/Modal";
import ModalContent from "components/ModalContent";
import ModalActions from "components/ModalActions";
import ExportDataControls from "components/ExportDataControls";
import { UI_THEME, STATUS } from "utils/constants/ui";
import Pill from "components/Pill";

const Controls = ({
  header,
  config,
  data,
  state,
  rows,
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  setFilter,
  setAllFilters,
  setPresentation,
  presentation,
  exportConfig,
  scrollTopOnChange
}) => {
  const [showModal, setShowModal] = useState(false);
  const selectConfig = get(config, "select", {});
  const actionsConfig = get(config, "actions", []);
  const presentationConfig = get(config, "presentation");
  const summaryFn = get(config, "summary");
  const summaryRows = summaryFn ? summaryFn(rows) : null;

  const selectProps = {
    data,
    config: selectConfig,
    onChange: setFilter,
    state: state.filters,
    scrollTopOnChange
  };
  const visibleFilters = xor(
    get(config, "initialState.hiddenColumns", []),
    get(config, "select.fields", [])
  );
  const showFilters = visibleFilters.length > 0;
  const showExportControls = Boolean(exportConfig && rows.length > 0);
  const hasActiveQuery = Boolean(state.globalFilter);
  const hasActiveFilters = Boolean(state.filters && state.filters.length > 0);
  const hasFiltersApplied = hasActiveQuery || hasActiveFilters;

  return (
    <div className="flex flex-column items-end">
      <div className="flex flex-column w-100">
        {header && <div className="f7 fw5 pb2">{header}</div>}
        <div className="flex flex-column flex-row-ns items-center-ns">
          <div className="flex flex-row items-center w-100">
            {showFilters && (
              <div className="db dn-ns pr2">
                <HoverIconButton
                  type={"filter"}
                  onClick={() => setShowModal(true)}
                />
              </div>
            )}
            {presentationConfig && (
              <div className="h-100 pr2 br hairline-1 dn flex-ns flex-row">
                <IconButtonBar
                  value={presentation}
                  config={presentationConfig}
                  onClick={setPresentation}
                />
              </div>
            )}
            <div className="w-100 pr2-ns">
              <GlobalFilter
                config={config}
                preGlobalFilteredRows={preGlobalFilteredRows}
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                scrollTopOnChange={scrollTopOnChange}
              />
            </div>
          </div>
          <div className="flex flex-row justify-end items-center-ns pt2 pt0-ns">
            {actionsConfig &&
              actionsConfig.map((action, actionIx) => (
                <div key={actionIx} className={actionIx ? "pl2" : ""}>
                  <Button {...action} />
                </div>
              ))}
            {config.canReset && (
              <div className={`dib ${showExportControls ? "pr2" : ""}`}>
                <Button
                  disabled={!hasFiltersApplied}
                  theme={UI_THEME.SLIM}
                  copy="Reset"
                  onClick={() => {
                    setGlobalFilter("");
                    setAllFilters([]);
                  }}
                />
              </div>
            )}
            {showExportControls && (
              <ExportDataControls {...exportConfig} rows={rows} />
            )}
          </div>
        </div>
      </div>
      <div className="dn db-ns">
        <SelectFields {...selectProps} />
      </div>
      {summaryRows ? (
        <div className="pt3 flex flex-row">
          {summaryRows.map(({ label, value }, summaryIx) => (
            <div className="dib pl1" key={summaryIx}>
              <Pill
                status={STATUS.SUCCESS}
                theme={UI_THEME.SLIM}
                copy={`${label}: ${value}`}
              />
            </div>
          ))}
        </div>
      ) : null}
      {showModal && (
        <Modal showModal={showModal} onClose={() => setShowModal(false)}>
          <ModalContent>
            {() => (
              <div className="w-100 flex flex-column">
                <SelectFields
                  {...selectProps}
                  customClasses={{
                    container: "flex flex-column flex-shrink-0 pt3",
                    item: "pb3"
                  }}
                />
                <ModalActions
                  actions={[
                    {
                      cta: "Close",
                      onClick: () => {
                        setShowModal(false);
                      }
                    }
                  ]}
                />
              </div>
            )}
          </ModalContent>
        </Modal>
      )}
    </div>
  );
};

export default Controls;
